import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import toast from 'react-hot-toast';
import PublicHeader from '../components/PublicHeader';
import PublicFooter from '../components/PublicFooter';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSent(false);
    try {
      const { data } = await api.post('/forgot-password', { email });
      toast.success(data.message || 'Email envoyé si cette adresse existe.');
      setSent(true);
    } catch (err) {
      const msg = err.response?.data?.message || 'Une erreur est survenue. Réessayez.';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <PublicHeader />
      <main id="main-content" className="flex-1 flex items-center justify-center pt-16 p-4" tabIndex={-1}>
        <div className="w-full max-w-md">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h1 className="text-2xl font-bold text-slate-800 mb-2 text-center">
              Mot de passe oublié
            </h1>
            <p className="text-slate-500 text-sm text-center mb-6">
              Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
            </p>
            {sent ? (
              <div className="text-center space-y-4">
                <p className="text-slate-600">
                  Si cette adresse existe dans notre système, vous recevrez un email avec un lien pour définir un nouveau mot de passe.
                </p>
                <p className="text-slate-500 text-sm">
                  Vérifiez vos spams si vous ne le voyez pas.
                </p>
                <Link
                  to="/login"
                  className="inline-block text-primary-600 hover:underline font-medium"
                >
                  Retour à la connexion
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4" aria-label="Demander un lien de réinitialisation">
                <div>
                  <label htmlFor="forgot-email" className="block text-sm font-medium text-slate-700 mb-1">
                    Email
                  </label>
                  <input
                    id="forgot-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                    className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent min-h-[44px]"
                    placeholder="votre@email.com"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  aria-busy={loading}
                  className="w-full py-2 px-4 min-h-[44px] bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 disabled:opacity-50 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                >
                  {loading ? 'Envoi...' : 'Envoyer le lien'}
                </button>
              </form>
            )}
            {!sent && (
              <p className="mt-6 text-sm text-center text-slate-500">
                <Link to="/login" className="text-primary-600 hover:underline">
                  Retour à la connexion
                </Link>
              </p>
            )}
          </div>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
